const fitFilterOrder: string[] = [
    'Race',
    'Core',
    'Slim',
    'Regular',
    'Relaxed',
    'Pro',
    'Team',
];

export function fitSort(a, b) {
    return fitFilterOrder.indexOf(a.label) - fitFilterOrder.indexOf(b.label);
}
